import { useState } from 'react';
import { formatWhen } from '../../utils/dateUtils';
import { ACTION_LABELS } from './helpers';

/** Earlier wordings of one note, behind a toggle. Approver view only. */
const EarlierVersions = ({ versions }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="ms-3">
      <button type="button" className="btn btn-link btn-sm p-0" onClick={() => setOpen(!open)}>
        {open ? 'Hide' : 'Show'} earlier versions ({versions.length})
      </button>
      {open && (
        <ul className="list-unstyled text-muted mb-0 ms-2">
          {versions.map((version, index) => (
            <li key={`${version.replaced_at}-${index}`}>
              <span className="fst-italic">“{version.note}”</span>
              {` · replaced by ${version.replaced_by_name}, ${formatWhen(version.replaced_at)}`}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

/**
 * Who did what to an expense, oldest first, with any notes.
 *
 * With onEditNote / onDeleteNote (the Review tab only) each note gets Edit and
 * Delete, and earlier wordings can be shown. Callbacks receive (index, entry);
 * the index is the entry's position in the full history.
 */
const ExpenseHistory = ({ history, onEditNote, onDeleteNote }) => {
  const editable = Boolean(onEditNote);
  return (
    <ul className="list-unstyled small mb-0">
      {(history || []).map((entry, index) => (
        <li key={`${entry.at}-${index}`} className="mb-1">
          <strong>{ACTION_LABELS[entry.action] || entry.action}</strong>
          {' by '}
          {entry.by_name}
          <span className="text-muted">{` · ${formatWhen(entry.at)}`}</span>
          {entry.note && (
            <div className="ms-3">
              <span className="fst-italic">“{entry.note}”</span>
              {entry.note_edited_at && (
                <span className="text-muted">
                  {` (edited by ${entry.note_edited_by_name}, ${formatWhen(entry.note_edited_at)})`}
                </span>
              )}
              {editable && (
                <>
                  <button
                    type="button"
                    className="btn btn-link btn-sm py-0"
                    onClick={() => onEditNote(index, entry)}
                    aria-label={`Edit note: ${entry.note}`}
                  >
                    Edit
                  </button>
                  {entry.action === 'rejected' ? (
                    <span className="text-muted" title="A rejection reason can be edited but not deleted">
                      <i className="bi bi-lock" aria-hidden="true"></i>
                    </span>
                  ) : (
                    <button
                      type="button"
                      className="btn btn-link btn-sm py-0 text-danger"
                      onClick={() => onDeleteNote(index, entry)}
                      aria-label={`Delete note: ${entry.note}`}
                    >
                      Delete
                    </button>
                  )}
                </>
              )}
            </div>
          )}
          {entry.detail && <div className="ms-3 text-muted">{entry.detail}</div>}
          {entry.note_deleted && (
            <div className="ms-3 text-muted">
              {`Note deleted by ${entry.note_deleted_by_name}, ${formatWhen(entry.note_deleted_at)}`}
            </div>
          )}
          {editable && entry.note_versions?.length > 0 && <EarlierVersions versions={entry.note_versions} />}
        </li>
      ))}
    </ul>
  );
};

export default ExpenseHistory;
